import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    root: {
        display: 'grid',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    governmentPlan: {
        backgroundColor: `${theme.palette.primary.main}`,
        "&:hover": {backgroundColor: "#AF516A"},
        "&.Mui-selected": {backgroundColor: "#AF516A"},
        "&.Mui-selected:hover": {backgroundColor: "#AF516A"}  
    }
}));